"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'MerchantDivisionConfig',
  data: function data() {
    return {
      detailLoading: false,
      submitLoading: false,
      editVisible: false,
      hasSearched: false,
      searchForm: {
        merId: ''
      },
      detail: {},
      routeMerchantName: '',
      editForm: {
        merId: null,
        receiverId: ''
      },
      editRules: {
        receiverId: [{
          max: 64,
          message: '接收方id长度不能超过64个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    hasDetail: function hasDetail() {
      return !!this.detail.merId;
    },
    displayMerchantName: function displayMerchantName() {
      return this.detail.merchantName || this.routeMerchantName || '';
    },
    emptyTitle: function emptyTitle() {
      return this.hasSearched ? '未查询到商户分账配置' : '请输入商户ID进行查询';
    },
    emptyDescription: function emptyDescription() {
      return this.hasSearched ? '请确认商户ID是否正确，或稍后重新查询。' : '支持从左侧菜单直接进入，也支持从商户列表带 merId 跳转进入。';
    }
  },
  watch: {
    '$route.query': {
      handler: function handler() {
        this.applyRouteQuery();
      },
      deep: true
    }
  },
  created: function created() {
    this.applyRouteQuery();
  },
  methods: {
    applyRouteQuery: function applyRouteQuery() {
      var merId = this.normalizeMerId(this.$route.query.merId);
      this.routeMerchantName = this.$route.query.merchantName || '';
      this.searchForm.merId = merId ? String(merId) : '';
      if (merId) {
        this.getDetail(merId);
      } else {
        this.detail = {};
        this.hasSearched = false;
      }
    },
    normalizeMerId: function normalizeMerId(value) {
      if (value === undefined || value === null || value === '') return '';
      var merId = Number(value);
      if (Number.isNaN(merId) || merId <= 0) return '';
      return merId;
    },
    handleSearch: function handleSearch() {
      var merId = this.normalizeMerId(this.searchForm.merId);
      if (!merId) {
        this.$message.warning('请输入正确的商户ID');
        return;
      }
      this.$router.replace({
        path: this.$route.path,
        query: {
          merId: String(merId),
          merchantName: this.routeMerchantName || this.displayMerchantName || ''
        }
      });
      this.getDetail(merId);
    },
    handleReset: function handleReset() {
      this.searchForm.merId = '';
      this.detail = {};
      this.routeMerchantName = '';
      this.hasSearched = false;
      this.$router.replace({
        path: this.$route.path,
        query: {}
      });
    },
    getDetail: function getDetail(merId) {
      var _this = this;
      this.detailLoading = true;
      this.hasSearched = true;
      (0, _merchant.merchantDivisionConfigApi)(merId).then(function (res) {
        _this.detail = res || {};
        if (res && res.merchantName) {
          _this.routeMerchantName = res.merchantName;
        }
      }).catch(function () {
        _this.detail = {};
      }).finally(function () {
        _this.detailLoading = false;
      });
    },
    openEditDialog: function openEditDialog() {
      var _this2 = this;
      this.editForm = {
        merId: this.detail.merId,
        receiverId: this.detail.jeequanMchNo || ''
      };
      this.editVisible = true;
      this.$nextTick(function () {
        if (_this2.$refs.editFormRef) _this2.$refs.editFormRef.clearValidate();
      });
    },
    resetEditForm: function resetEditForm() {
      if (this.$refs.editFormRef) this.$refs.editFormRef.resetFields();
      this.editForm = {
        merId: null,
        receiverId: ''
      };
    },
    handleSave: function handleSave() {
      var _this3 = this;
      if (!this.$refs.editFormRef) return;
      this.$refs.editFormRef.validate(function (valid) {
        if (!valid) return false;
        _this3.submitLoading = true;
        (0, _merchant.merchantDivisionConfigUpdateApi)({
          merId: _this3.detail.merId,
          jeequanMchNo: _this3.editForm.receiverId
        }).then(function () {
          _this3.$message.success('保存成功');
          _this3.editVisible = false;
          _this3.getDetail(_this3.detail.merId);
        }).finally(function () {
          _this3.submitLoading = false;
        });
      });
    },
    displayValue: function displayValue(value) {
      if (value === undefined || value === null || value === '') return '-';
      return value;
    },
    statusText: function statusText(status) {
      if (!status) return '未配置';
      return status;
    },
    statusTagType: function statusTagType(status) {
      var statusMap = {
        BOUND: 'success',
        SUCCESS: 'success',
        PENDING: 'warning',
        PROCESSING: 'warning',
        FAILED: 'danger',
        FAIL: 'danger',
        ERROR: 'danger',
        UNBOUND: 'info'
      };
      return statusMap[String(status).toUpperCase()] || 'info';
    },
    shouldShowReceiverFailReason: function shouldShowReceiverFailReason(detail) {
      if (!detail || !detail.receiverFailReason) return false;
      var status = String(detail.receiverBindStatus || '').toUpperCase();
      return status !== 'BOUND' && status !== 'SUCCESS';
    },
    formatTime: function formatTime(value) {
      if (!value) return '-';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      var pad = function pad(num) {
        return String(num).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};